import React from 'react';
import "../../../style/largeScreen/index.css";
import ChartBar from '../demo/chart/ChartBar2';
import CountUp from 'react-countup';
import http from '../../../axios/http';

class DealChart extends React.Component {
    state = {
        dataInfo:{
            todayAccount:0,
            todayNum:0,
            yearAccount:0,
            yearNum:0,
        },
        tableData:[],
        finishedStart: 0,
        showNum: 10,    //显示条数
    }
  
    // calculationWidth(data) {
    //     let tWidth = (data / 100) * 1000;
    //     // let tWidth = data * 10 ;
    //     return tWidth;
    // }
    componentDidMount() {
        this.timer();
        this.interval = setInterval(() => this.timer(), 5000);
    }
    componentWillUnmount() {
        clearInterval(this.interval);
    }

    loadTableData(){
        http.post({
            url: '/applySummary/findMemberApplySummary',
            success: (res) => {
                let objData ={};
                let listData=[];
                for(let i=0;i<res.list.length;i++){
                    if(res.list[i].monthCount !==0){
                        objData[i]=res.list[i];
                        objData[i].id = i+1;
                        // objData[0].proportion =  30;
                        objData[i].proportion =  (res.list[i].monthCount/res.monthCount*100).toFixed(2);
                        objData[i].width =  (res.list[i].monthCount/res.list[0].monthCount*100) +"%";
                        listData.push(objData[i]);
                    }
                }
                this.setState({
                    tableData:listData,
                    finishedStart: 0,
                })
            }
        });  
    }
    componentWillMount(){
        http.post({
            url: '/applySummary/findTradeSummary',
            success: (res) => {
                this.setState({
                    dataInfo:{
                        todayAccount:res.todayAccount,
                        todayNum:res.todayNum,
                        yearAccount:res.yearAccount,
                        yearNum:res.yearNum,
                    }
                })
            }
        });  
       
    }
    timer = () => {
        let finishedStart = (this.state.finishedStart) * (this.state.showNum);
        let finishedLength = this.state.tableData.length - this.state.showNum;
        if (finishedStart >= finishedLength) {
            //如果两个开始都大于结束的最大长度，说明已经滚动完了。需要重新加载
            this.loadTableData();
        } else {
            //不需要重新加载，只需要将两个列表滚动播放
            finishedStart = finishedStart >= finishedLength ? 0 : this.state.finishedStart + 1;
        }
        this.setState({
            finishedStart: finishedStart,
        });
    }

    render() {
        const { darkBackground } = this.props;

        let start = (this.state.finishedStart) * (this.state.showNum);
        let end = start + this.state.showNum;
        end = end > this.state.tableData.length ? this.state.tableData.length : end;
        let tableData = this.state.tableData.slice(start, end);
        return (
            <div className="contentBg" style={{ width: "100%", height: "100%" }}>
                <div  className='initPosi acount'>
                    <div className='todayAcount'>
                        {/* {account} */}
                        <span className='todayAcount-txt'>今日交易额（元）</span>
                        <span className="todayAcount-money"><CountUp start={0} separator="," end={this.state.dataInfo.todayAccount} /></span>
                    </div>
                    <div></div>
                    <div className="todayAcount-detail">
                        <div className="todayAcount-content">
                            <div className="todayAcount-title">今日交易量（辆）<span className="todayAcount-num"><CountUp separator="," start={0} end={this.state.dataInfo.todayNum} /></span></div>
                            <div className="todayAcount-num"></div>
                        </div>
                        <div className="todayAcount-content">
                            <div className="todayAcount-title">年交易量（辆）<span className="todayAcount-num"><CountUp separator="," start={0} end={this.state.dataInfo.yearNum} /></span></div>
                            <div className="todayAcount-num">  </div>
                        </div>
                        <div className="todayAcount-content">
                            <div className="todayAcount-title">年交易额(（元）<span className="todayAcount-num"><CountUp separator="," start={0} end={this.state.dataInfo.yearAccount} /></span></div>
                            <div className="todayAcount-num"> </div>
                        </div>
                    </div>
                </div>
                <div style={fullScreenStyle} className='content'>
                    <div style={{ ...chartDivStyle, borderTop: 0 }}>
                        <div style={chartSubDivStyle}>
                            <ChartBar domId="bar1" isFullScreen={darkBackground} />
                        </div>
                    </div>
                    <div className="acountTop">
                        <table>
                            <thead>
                                <tr>
                                    <th  className='acountTop-title' colSpan='4'>商户排名</th>
                                </tr>
                                <tr>
                                    <th className='acountTop-id'>排名</th>
                                    <th className='acountTop-name'>商户</th>
                                    <th className='acountTop-proportion'>占比</th>
                                    <th className='acountTop-width'></th>
                                </tr>
                            </thead>
                            <tbody className='acountTop-content'>
                                {
                                   tableData.map((item, index) => {
                                        return <tr key={index}>
                                            <td className='acountTop-id'><span>{item.id}</span></td>
                                            <td className='acountTop-name'>{item.name}</td>
                                            <td className='acountTop-proportion'>{item.proportion}%</td>
                                            <td className="acountTop-width lineWidth"><div className="dataLine" style={{ width:item.width}} ></div></td>
                                        </tr>
                                    })
                                }
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        )
    }
}

const fullScreenStyle = {
    // position: 'relative',
    // top: '0',
    // left: '0', 
    // background: '#282C34',
    width: '100%',
    // height: '100%'
}

const chartDivStyle = {
    width: '50%', height: '100%', float: 'left', border: '1px solid #cccccc', borderBottom: '0', borderLeft: '0'
}

const chartSubDivStyle = {
    width: '96%', height: '98%', margin: '1%'
}

export default DealChart;